import { Cancel, Check } from "@mui/icons-material";
import {
  Alert,
  AlertProps,
  ClickAwayListener,
  Fade,
  IconButton,
  Popper,
} from "@mui/material";
import React, { ReactNode, useState } from "react";

interface Props {
  disabled?: boolean;
  children: ReactNode;
  popperContent: React.ReactNode;
  onConfirmHandler?: () => void;
  alertProps?: AlertProps;
}

export default function ConfirmationPopper({
  alertProps,
  children,
  disabled,
  popperContent,
  onConfirmHandler,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined);

  function setNotPopped() {
    setAnchorEl(undefined);
  }

  return (
    <>
      <ClickAwayListener onClickAway={setNotPopped}>
        <div
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          }}
        >
          {children}
        </div>
      </ClickAwayListener>
      <Popper
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        transition
        placement="bottom"
        keepMounted
        sx={({ zIndex }) => ({ zIndex: zIndex.tooltip })}
        disablePortal={false}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Alert
              action={
                <>
                  {onConfirmHandler && (
                    <IconButton
                      size="small"
                      color="success"
                      disabled={disabled}
                      onClick={(event) => {
                        event.stopPropagation();
                        onConfirmHandler();
                        setNotPopped();
                      }}
                    >
                      <Check />
                    </IconButton>
                  )}
                  <IconButton
                    size="small"
                    sx={({ palette }) => ({ color: palette.error.dark })}
                    onClick={setNotPopped}
                  >
                    <Cancel />
                  </IconButton>
                </>
              }
              sx={(theme) => ({
                boxShadow: theme.boxShadows.md,
                backgroundColor: theme.palette.grey[200],
              })}
              {...alertProps}
            >
              {anchorEl && popperContent}
            </Alert>
          </Fade>
        )}
      </Popper>
    </>
  );
}
